import Vue from 'vue';
import VueRouter from 'vue-router';
import { userType } from '@/plugins/enums';
import store from './store/store';
import { baseStore } from 'erp-skeleton-library/base-store/base-store';
import { hideFabButtons, isNullOrEmpty, verifyDebug } from 'erp-skeleton-library/utils';
import { usersTenants } from './plugins/enums';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER, usersTenants.TYPE_TECHNICIAN, usersTenants.TYPE_SUPERVISOR ],
          },
          component: () => import('./views/Dashboard.vue'),
        },
        {
          path: '/service-orders',
          name: 'service-order',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER, usersTenants.TYPE_TECHNICIAN, usersTenants.TYPE_SUPERVISOR ],
          },
          component: () => import('./views/service-order/ServiceOrder.vue'),
        },
        {
          path: '/service-orders/new',
          name: 'service-orders-new',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/service-order/ServiceOrderRegister.vue'),
        },
        {
          path: '/service-orders/:id',
          name: 'service-orders-edit',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER, usersTenants.TYPE_TECHNICIAN, usersTenants.TYPE_SUPERVISOR ],
          },
          component: () => import('./views/service-order/ServiceOrderRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/pra/parties',
          name: 'parties',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/parties/Parties.vue'),
        },
        {
          path: '/pra/parties/new',
          name: 'parties-register',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/parties/PartiesRegister.vue'),
        },
        {
          path: '/pra/parties/:id',
          name: 'parties-edit',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/parties/PartiesRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/pra/register/tenant/collaborators',
          name: 'tenant-collaborators',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/collaborators/TenantCollaborator.vue'),
        },
        {
          path: '/pra/register/tenant/collaborators/new',
          name: 'tenant-collaborators-register',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/collaborators/TenantCollaboratorRegister.vue'),
        },
        {
          path: '/pra/register/tenant/collaborators/:id',
          name: 'tenant-collaborators-edit',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/collaborators/TenantCollaboratorRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/pra/register/technicians',
          name: 'technicians',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/technicians/Technician.vue'),
        },
        {
          path: '/pra/register/technicians/new',
          name: 'technicians-register',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/technicians/TechnicianRegister.vue'),
        },
        {
          path: '/pra/register/technicians/:id',
          name: 'technicians-edit',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/technicians/TechnicianRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/pra/register/supervisors',
          name: 'supervisors',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/supervisors/Supervisor.vue'),
        },
        {
          path: '/pra/register/supervisors/new',
          name: 'supervisors-register',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/supervisors/SupervisorRegister.vue'),
        },
        {
          path: '/pra/register/supervisors/:id',
          name: 'supervisors-edit',
          meta: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/supervisors/SupervisorRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/pra/reports',
          name: 'pra-reports',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/Reports.vue'),
        },
        {
          path: '/pra/tasks',
          name: 'pra-tasks',
          meta: {
            userType: [ userType.TYPE_ADMIN ],
          },
          component: () => import('./views/pra-tasks/PraTask.vue'),
        },
        {
          path: '/pra/tasks/new',
          name: 'pra-tasks-register',
          meta: {
            userType: [ userType.TYPE_ADMIN ],
          },
          component: () => import('./views/pra-tasks/PraTaskRegister.vue'),
        },
        {
          path: '/pra/tasks/:id',
          name: 'pra-tasks-edit',
          meta: {
            userType: [ userType.TYPE_ADMIN ],
          },
          component: () => import('./views/pra-tasks/PraTaskRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/profile',
          name: 'profile',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/Profile.vue'),
        },
      ],
    },
    {
      path: '*',
      name: 'login',
      component: () => import('./views/Index.vue'),
    },
  ],
});


router.beforeEach((to, from, next) => {
  hideFabButtons();
  verifyDebug();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: '/login',
      });
    } else if (!sessionStorage.getItem('tokenIsValid')) {
      store.dispatch('users/verifyUserStatus', baseStore.state.appUser.id)
           .then(() => {
             sessionStorage.setItem('tokenIsValid', 'true');
             next();
           });
    } else {
      if (navigationGuard(to.meta, baseStore.state.appUser)) {
        next();
      } else {
        next({ path: '/dashboard' });
      }
    }
  } else {
    if (store.getters.loggedIn) {
      next({
        path: '/dashboard',
      });
    } else {
      next();
    }
  }
});

function navigationGuard(pathMeta, appUser) {
  if (appUser.type !== userType.TYPE_USER) {
    if(pathMeta.userType.includes(parseInt(appUser.type))) {
      return true;
    } else {
      return (!isNullOrEmpty(appUser.tenants) && appUser.tenants[0].tenant.pra);
    }
  }

  //Tenant (Type User)
  if(hasTenantPermission(pathMeta)) {
    if(pathMeta.tenantUserType.includes(store.getters.getUserType.tenantUserType)) {
      return (!isNullOrEmpty(appUser.tenants) && appUser.tenants[0].tenant.pra);
    } else {
      return pathMeta.tenantUserType.includes(store.getters.getUserType.tenantUserType);
    }
  }
}

function hasTenantPermission(pathMeta) {
  return pathMeta.tenantUserType;
}

export default router;
